import CourseContentLayoutOperations from "./CourseContentLayoutOperations";

function JuniorCourse(props) {
  return <CourseContentLayoutOperations {...props} totalModules={3} />;
}

export default JuniorCourse;